var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref, watch } from "vue";
import { fetch } from "@/components/User/DiskUsage/Quota/services";
import { errorMessageAsString } from "@/utils/simple-error";
import QuotaUsageBar from "@/components/User/DiskUsage/Quota/QuotaUsageBar.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuQuotaSource',
    props: {
        name: null,
        filter: null,
        filters: null,
        identifier: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        const propValue = computed(() => props.filters[props.name]);
        const localValue = ref(propValue.value);
        watch(() => localValue.value, () => {
            emit("change", props.name, localValue.value);
        });
        watch(() => propValue.value, () => {
            localValue.value = propValue.value;
        });
        const quotaUsages = ref([]);
        const errorMessage = ref();
        function loadQuotaUsages() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    quotaUsages.value = yield fetch();
                }
                catch (e) {
                    errorMessage.value = errorMessageAsString(e);
                }
            });
        }
        const hasMultipleQuotaSources = computed(() => {
            return !!(quotaUsages.value && quotaUsages.value.length > 1);
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield loadQuotaUsages();
        }));
        function isQuotaUsage(value) {
            return !!(value && value instanceof Object && "rawSourceLabel" in value);
        }
        const dropDownText = computed(() => {
            if (isQuotaUsage(localValue.value)) {
                return localValue.value.sourceLabel;
            }
            else {
                return "(any)";
            }
        });
        function setValue(val) {
            localValue.value = val;
        }
        return { __sfc: true, props, emit, propValue, localValue, quotaUsages, errorMessage, loadQuotaUsages, hasMultipleQuotaSources, isQuotaUsage, dropDownText, setValue, QuotaUsageBar };
    }
});
